<template>
    <v-card class="px-3 pb-0">
        <ConfirmacaoModal
            v-if="mostrarModalConfirmacao"
            :showDialog="mostrarModalConfirmacao"
            :tituloModal="tituloModalConfirmacao"
            :textoModal="textoModalConfirmacao"
            :btnConfirmarEmit="btnConfirmarModalConfirmacao"
            :esconderCancelar="false"
            :btnConfirmar="btnConfirmarLabel"
            @invalidarInstrumento="invalidarInstrumento"
            @fecharModal="
                mostrarModalConfirmacao = false;
                esconderCancelar = false;
            "
        />
        <v-row>
            <v-col>
                <h4 class="bold">Informações do Título</h4>
            </v-col>
            <v-col class="d-flex justify-end">
                <select-actions
                    @executeAction="callMethod"
                    :actions="[
                        {
                            name: 'Irregularizar: Cartório inativo',
                            method: 'irregularizarTitulo',
                            disabled: !statusParaIrregularizarTitulo.includes(
                                titulo.cd_status
                            )
                        },
                        {
                            name: 'Irregularizar: Erro do cartório',
                            method: 'irregularizarTituloK3',
                            disabled: !statusParaIrregularizarTituloK3.includes(
                                titulo.cd_status
                            )
                        },
                        {
                            name: 'Enviar a Negociação',
                            method: 'enviarNegociacao',
                            disabled: !statusParaRenegociarProtestar.includes(
                                titulo.cd_status
                            )
                        },
                        {
                            name: 'Enviar a Protesto',
                            method: 'enviarProtesto',
                            disabled: !statusParaRenegociarProtestar.includes(
                                titulo.cd_status
                            )
                        },
                        {
                            name: 'Reiniciar Envio',
                            method: 'reiniciarEnvio',
                            disabled: desabilitaBotaoFila
                        },
                        {
                            name: 'Invalidar Instrumento de Protesto',
                            method: 'modalInvalidarInstrumento',
                            disabled: !instrumentoProtesto
                        },
                        {
                            name: 'Resumo do Título',
                            method: 'copiarResumoTitulo',
                            disabled: false
                        }
                    ]"
                />
            </v-col>
        </v-row>
        <v-row class="mt-3">
            <v-col class="pb-3">
                <v-text-field
                    outlined
                    dense
                    :value="titulo.cd_status + ' - ' + titulo.ds_status"
                    label="Status"
                    readonly
                    hide-details="auto"
                ></v-text-field>
            </v-col>
            <v-col class="pb-3" cols="2">
                <v-text-field
                    outlined
                    dense
                    :value="titulo.id_titulo"
                    label="ID"
                    readonly
                    hide-details="auto"
                ></v-text-field>
            </v-col>
            <v-col class="pb-3" cols="2">
                <v-text-field
                    outlined
                    dense
                    :value="titulo.ds_numero_titulo"
                    label="Número do Título"
                    readonly
                    hide-details="auto"
                ></v-text-field>
            </v-col>
            <v-col class="pb-3" cols="2">
                <v-text-field
                    outlined
                    dense
                    :value="titulo.nu_parcela"
                    label="Parcela"
                    hide-details="auto"
                    readonly
                ></v-text-field>
            </v-col>
            <v-col class="pb-3" cols="2">
                <v-text-field
                    outlined
                    dense
                    :value="titulo.ds_nosso_numero"
                    label="Nosso Número"
                    hide-details="auto"
                    readonly
                ></v-text-field>
            </v-col>
        </v-row>
        <v-row class="mt-0">
            <v-col class="pb-3">
                <v-text-field
                    outlined
                    dense
                    :value="'R$ ' + titulo.vl_saldo_protesto_formatado"
                    label="Valor Protestado"
                    readonly
                    hide-details="auto"
                ></v-text-field>
            </v-col>
            <v-col class="pb-3">
                <v-text-field
                    outlined
                    dense
                    :value="'R$' + titulo.vl_titulo_formatado"
                    label="Valor total do Título"
                    readonly
                    hide-details="auto"
                ></v-text-field>
            </v-col>
            <v-col class="pb-3">
                <v-text-field
                    outlined
                    dense
                    :value="formatDate(titulo.dt_emissao)"
                    label="Data de emissão"
                    hide-details="auto"
                    readonly
                ></v-text-field>
            </v-col>
            <v-col class="pb-3">
                <v-text-field
                    outlined
                    dense
                    :value="formatDate(titulo.dt_vencimento)"
                    label="Data de vencimento"
                    hide-details="auto"
                    readonly
                ></v-text-field>
            </v-col>
            <v-col class="pb-3">
                <v-text-field
                    outlined
                    dense
                    :value="'R$ ' + (titulo.vl_repassado_formatado || '0,00')"
                    label="Valor Repasse"
                    hide-details="auto"
                    readonly
                ></v-text-field>
            </v-col>
            <v-col
                v-if="[103, 121].includes(titulo.cd_status)"
                class="pb-3"
            >
                <v-text-field
                    outlined
                    dense
                    :value="'R$ ' + (titulo.vl_custas_formatado || '0,00')"
                    label="Custas Finais"
                    hide-details="auto"
                    readonly
                ></v-text-field>
            </v-col>
        </v-row>
        <v-row class="mt-0">
            <v-col class="pb-3">
                <v-text-field
                    outlined
                    dense
                    :value="titulo.cd_especie_titulo"
                    label="Espécie"
                    hide-details="auto"
                    readonly
                ></v-text-field>
            </v-col>
            <v-col class="pb-3">
                <v-text-field
                    outlined
                    dense
                    :value="titulo.tp_declaracao"
                    label="Declaração"
                    hide-details="auto"
                    readonly
                ></v-text-field>
            </v-col>
            <v-col class="pb-3">
                <v-text-field
                    outlined
                    dense
                    :value="titulo.tp_endosso || ' '"
                    label="Endosso"
                    hide-details="auto"
                    readonly
                ></v-text-field>
            </v-col>
            <v-col class="pb-3">
                <v-text-field
                    outlined
                    dense
                    :value="titulo.tp_aceite"
                    label="Aceite"
                    hide-details="auto"
                    readonly
                ></v-text-field>
            </v-col>
            <v-col class="pb-3">
                <v-text-field
                    outlined
                    dense
                    :value="titulo.cd_falimentar || '  '"
                    label="Falimentar"
                    hide-details="auto"
                    readonly
                ></v-text-field>
            </v-col>
            <v-col class="pb-3">
                <v-text-field
                    outlined
                    dense
                    :value="titulo.ds_agrupador"
                    label="Agrupador"
                    hide-details="auto"
                    readonly
                ></v-text-field>
            </v-col>
        </v-row>
        <v-row class="mt-0">
            <v-col
                v-if="valorEmolumentoReal.total == 0"
                cols="12"
                sm="6"
                md="4"
                lg="4"
            >
                <v-text-field
                    outlined
                    dense
                    hide-details
                    v-model="valorEmolumento"
                    label="Valor estimado de Emolumentos"
                    required
                    readonly
                ></v-text-field>
            </v-col>
            <v-col
                v-if="valorEmolumentoReal.total != 0"
                cols="12"
                sm="6"
                md="4"
                lg="4"
            >
                <div class="d-flex align-center">
                    <v-text-field
                        outlined
                        dense
                        hide-details
                        v-model="valorEmolumentoReal.total"
                        label="Valor Real de Emolumentos"
                        required
                        readonly
                        class="flex-grow-1"
                    ></v-text-field>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon class="ml-2" v-bind="attrs" v-on="on">
                                mdi-information-outline
                            </v-icon>
                        </template>
                        <div class="text-left">
                            <p
                                v-for="(item,
                                key) in valorEmolumentoRealFiltrado"
                                :key="key"
                            >
                                {{ item.label }}: {{ item.value }}
                            </p>
                        </div>
                    </v-tooltip>
                </div>
            </v-col>
        </v-row>
        <Snackbar
            data-html2canvas-ignore
            v-if="feedbackSnackbar"
            :mostrarSnackbar="feedbackSnackbar"
            :corSnackbar="feedbackSnackbarColor"
            :mensagemSnackbar="mensagemfeedbackSnackbar"
            @fecharSnackbar="feedbackSnackbar = false"
        />
    </v-card>
</template>
<script>
import SelectActions from '../atoms/SelectActions.vue';
import EmolumentosService from '@/services/EmolumentosService';
import TituloService from '@/services/TituloService';
import ConfirmacaoModal from '@/modals/ConfirmacaoModal';
import Vue from 'vue';
import { getMensagemRequest } from '@/helpers/Utilitarios';
import moment from 'moment';
import { getValorEmolumento } from '../../helpers/Utilitarios';
export default {
    name: 'CardInformacoesTitulo',
    components: {
        SelectActions,
        ConfirmacaoModal
    },
    props: {
        titulo: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            statusParaIrregularizarTitulo: [220, 221, 225],
            statusParaIrregularizarTituloK3: [220, 221, 225, 230, 252, 250],
            statusParaRenegociarProtestar: [304, 305, 303],
            desabilitaBotaoFila: true,
            dt_ontem: moment()
                .subtract(1, 'days')
                .format('YYYY-MM-DD'),
            emolumentosService: new EmolumentosService(Vue.http, this.$store),
            tituloService: new TituloService(Vue.http, this.$store),
            loading: false,
            mostrarModalConfirmacao: false,
            tituloModalConfirmacao: '',
            textoModalConfirmacao: '',
            btnConfirmarLabel: '',
            btnConfirmarModalConfirmacao: '',
            instrumentoProtesto: null,
            feedbackSnackbarTimeout: 5000,
            feedbackSnackbarColor: '',
            mensagemfeedbackSnackbar: '',
            feedbackSnackbar: false,
            valorEmolumento: 0,
            valorEmolumentoReal: {
                valorProtestado: 0,
                valorEdital: 0,
                valorIntimacao: 0,
                valorEmolumentos: 0,
                valorCancelamento: 0,
                issEmolumento: 0,
                issCancelamento: 0,
                issTotal: 0,
                total: 0
            }
        };
    },
    created() {
        moment.locale('pt-br');
    },
    computed: {
        valorEmolumentoRealFiltrado() {
            const items = [
                {
                    label: 'Valor Protestado',
                    value: this.valorEmolumentoReal.valorProtestado
                },
                {
                    label: 'Valor do Edital',
                    value: this.valorEmolumentoReal.valorEdital
                },
                {
                    label: 'Valor da Intimação',
                    value: this.valorEmolumentoReal.valorIntimacao
                },
                {
                    label: 'Valor dos emolumentos',
                    value: this.valorEmolumentoReal.valorEmolumentos
                },
                {
                    label: 'Valor do Cancelamento',
                    value: this.valorEmolumentoReal.valorCancelamento
                },
                {
                    label: 'ISS Emolumento',
                    value: this.valorEmolumentoReal.issEmolumento
                },
                {
                    label: 'ISS Cancelamento',
                    value: this.valorEmolumentoReal.issCancelamento
                },
                { label: 'ISS Total', value: this.valorEmolumentoReal.issTotal }
            ];

            return items.filter(item => {
                const value =
                    typeof item.value === 'string'
                        ? item.value.replace('R$ ', '').replace(',', '.')
                        : item.value;
                return value;
            });
        }
    },
    async mounted() {
        this.buscarInstrumentoProtesto();
        await Promise.all([
            this.getValorEmolumento(),
            this.getValorEmolumentoReal()
        ]);
    },
    methods: {
        getMensagemRequest,
        setFeedbackSnackbar(color, message) {
            this.feedbackSnackbarColor = color;
            this.mensagemfeedbackSnackbar = message;
            this.feedbackSnackbar = true;
        },
        formatCurrency(value) {
            if (value === null || value === undefined) return 0;
            const number =
                typeof value === 'string' ? parseFloat(value) : value;
            if (isNaN(number)) return 0;
            return (
                'R$ ' +
                number.toLocaleString('pt-BR', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                })
            );
        },
        async getValorEmolumentoReal() {
            try {
                const resp = await this.emolumentosService.getValorEmolumentoReal(
                    { id_titulo: this.titulo.id_titulo }
                );
                if (resp && resp.data && resp.data.length > 0) {
                    this.valorEmolumentoReal = {
                        valorProtestado: this.formatCurrency(
                            resp.data[0].valor_real_emolumento
                                .valor_protestado || 0
                        ),
                        valorEdital: this.formatCurrency(
                            resp.data[0].valor_real_emolumento.valor_edital || 0
                        ),
                        valorIntimacao: this.formatCurrency(
                            resp.data[0].valor_real_emolumento
                                .valor_intimacao || 0
                        ),
                        valorEmolumentos: this.formatCurrency(
                            resp.data[0].valor_real_emolumento
                                .valor_emolumentos || 0
                        ),
                        valorCancelamento: this.formatCurrency(
                            resp.data[0].valor_real_emolumento
                                .valor_cancelamento || 0
                        ),
                        issEmolumento: this.formatCurrency(
                            resp.data[0].valor_real_emolumento.iss_emolumento ||
                                0
                        ),
                        issCancelamento: this.formatCurrency(
                            resp.data[0].valor_real_emolumento
                                .iss_cancelamento || 0
                        ),
                        issTotal: this.formatCurrency(
                            resp.data[0].valor_real_emolumento.iss_total || 0
                        ),
                        total:
                            this.formatCurrency(
                                resp.data[0].valor_real_emolumento
                                    .total_emolumentos
                            ) || 0
                    };
                } else {
                    this.valorEmolumentoReal = {
                        valorProtestado: 0,
                        valorEdital: 0,
                        valorIntimacao: 0,
                        valorEmolumentos: 0,
                        valorCancelamento: 0,
                        issEmolumento: 0,
                        issCancelamento: 0,
                        issTotal: 0,
                        total: 0
                    };
                }
            } catch (error) {
                console.log(error);
            }
        },
        async getValorEmolumento() {
            try {
                this.valorEmolumento = await getValorEmolumento(
                    Vue.http,
                    this.$store,
                    this.titulo.id_titulo
                );
            } catch (error) {
                this.emitirSnackbar(
                    'error',
                    'Erro ao buscar valor do emolumento'
                );
            }
        },
        modalInvalidarInstrumento() {
            this.tituloModalConfirmacao = 'Invalidar Instrumento de Protesto';
            this.textoModalConfirmacao =
                'Após invalidar um Instrumento de Protesto, ele ficará indisponível permanentemente e será necessário realizar uma nova solicitação. <br /><br />Deseja prosseguir?';
            this.btnConfirmarLabel = 'Confirmar';
            this.btnConfirmarModalConfirmacao = 'invalidarInstrumento';
            this.mostrarModalConfirmacao = true;
        },
        buscarInstrumentoProtesto() {
            this.tituloService
                .buscarAnexoTitulo(this.titulo, 'IP')
                .then(
                    response => {
                        if (Object.keys(response.body).length > 0) {
                            this.instrumentoProtesto = response.body;
                        } else {
                            this.instrumentoProtesto = null;
                        }
                    },
                    error => {
                        console.log(error);
                        this.setFeedbackSnackbar(
                            'error',
                            'Erro ao buscar Instrumento de Protesto'
                        );
                    }
                )
                .finally(() => {
                    this.loadingInstrumento = false;
                });
        },
        async invalidarInstrumento() {
            try {
                this.loading = true;
                this.mostrarModalConfirmacao = false;
                await this.tituloService.invalidarInstrumento(this.titulo);

                this.setFeedbackSnackbar(
                    'success',
                    'Instrumento de Protesto invalidado com sucesso!'
                );
                this.exibirDetalhe();
                this.buscarInstrumentoProtesto();
            } catch (e) {
                const mensagem = this.getMensagemRequest(
                    e.data,
                    'Erro ao invalidar Instrumento de Protesto'
                );
                this.setFeedbackSnackbar('error', mensagem);
            } finally {
                this.loading = false;
            }
        },
        formatDate(date) {
            return moment(date).format('DD/MM/YYYY');
        },
        callMethod(method) {
            method === 'irregularizarTitulo' &&
                this.$emit('alterarStatus', 105, 'K1');
            method === 'irregularizarTituloK3' &&
                this.$emit('alterarStatus', 105, 'K3');
            method === 'enviarNegociacao' && this.$emit('alterarStatus', 320);
            method === 'enviarProtesto' && this.$emit('alterarStatus', 220);
            method === 'reiniciarEnvio' && this.$emit('reiniciarEnvio');
            method === 'modalInvalidarInstrumento' &&
                this.modalInvalidarInstrumento();
            method === 'copiarResumoTitulo' && this.copiarResumoTitulo();
        },
        copiarResumoTitulo() {
            const dt_protocolo = this.titulo.apontamento_dt_protocolo
                ? moment(this.titulo.apontamento_dt_protocolo).format('DD/MM/YYYY')
                : '';
            const documento = (this.titulo.nu_identificacao_devedor || '').replace(/[^a-zA-Z0-9]/g, '');
            const texto = [
                `Apresentante: ${this.titulo.nm_razao_social || ''}`,
                `Sigla: ${this.titulo.cd_apresentante || ''}`,
                `UF: ${this.titulo.cd_uf_devedor || ''}`,
                `Nosso Número: ${this.titulo.ds_nosso_numero || ''}`,
                `Devedor: ${this.titulo.nm_devedor || ''}`,
                `Documento: ${documento}`,
                `Valor Protestado: ${this.titulo.vl_saldo_protesto_formatado || ''}`,
                `Protocolo: ${this.titulo.apontamento_nu_protocolo || ''}`,
                `Data do protocolo: ${dt_protocolo}`,
                `Comarca: ${this.titulo.apontamento_cd_municipio || ''}`,
                `Cartorio: ${this.titulo.apontamento_nu_cartorio || ''} - ${this.titulo.nm_cartorio_apontamento || ''}`,
                `Status: ${this.titulo.ds_status || ''}`
            ].join('\n');
            navigator.clipboard
                .writeText(texto)
                .then(() => {
                    this.setFeedbackSnackbar(
                        'success',
                        'Resumo do Título copiado para a área de transferência.'
                    );
                })
                .catch(() => {
                    this.setFeedbackSnackbar(
                        'error',
                        'Erro ao copiar para a área de transferência.'
                    );
                });
        },
        verificaStEnvio() {
            if (this.titulo.st_envio === -1 || this.titulo.st_envio === 1) {
                if (this.titulo.dt_atualizacao > this.dt_ontem) {
                    //aqui habilita o botão
                    this.desabilitaBotaoFila = false;
                } else {
                    this.desabilitaBotaoFila = true;
                }
            } else {
                this.desabilitaBotaoFila = true;
            }
        }
    }
};
</script>
